<template>
  <div class="container">
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">{{
          $t('lbl.communications.page_header')
        }}</v-toolbar-title>
      </v-col>
    </v-row>
    <v-row class="custom-form-control custom-form-control-type-2 custom-figma-1">
      <v-col cols="12" class="search-conditions-display">
        <div class="pl-0 pt-0 pb-0 collapse-search-conditions hide">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('collapse')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-up</v-icon>
            {{ $t('btn.common.collapseConditions') }}
          </v-btn>
        </div>
        <div class="pl-0 pt-0 pb-0 expand-search-conditions">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('expand')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-down</v-icon>
            {{ $t('btn.common.expandConditions') }}
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <v-row>
          <v-col
            class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-figma-1"
            cols="12"
            lg="8"
            md="8"
          >
            <v-row>
              <v-col cols="12" lg="4" md="3" class="pt-0 pb-0">
                <v-text-field
                  v-model="s_item.vname"
                  @keyup.enter.native="searchItem"
                  :label="$t('lbl.common.conditionSearch.findbyName')"
                  class="custom-selectbox"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="2" md="3" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="s_item.vtype"
                  :items="types"
                  :menu-props="{ offsetY: true }"
                  :label="$t('lbl.common.conditionSearch.selectType')"
                  @change="searchItem"
                  class="custom-selectbox"
                  hide-details
                  dense
                  filled
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="6" md="3" class="pt-0 pb-0">
                <v-text-field
                  v-model="s_item.vendpoint"
                  @keyup.enter.native="searchItem"
                  :label="$t('lbl.common.conditionSearch.connectorEndPoint')"
                  class="custom-selectbox"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            class="comm-header-col date-query-section pb-0 pt-0 pr-0 mt-0 text-right custom-figma-1"
            cols="12"
            lg="4"
            md="4"
          >
            <div class="pl-0 pt-0 pb-0 d-inline-flex btn-control"></div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex btn-control">
              <v-btn class="btn btn-search btn-width-1" color="primary" @click.native="searchItem">
                <v-icon x-small class="mr-2">fa fa-search</v-icon>{{ $t('btn.common.search') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="custom-pagination-figma-v3-first">
      <v-col class="page-control-content page-control-bg">
        <v-row>
          <v-col lg="6" md="6">
            <v-row>
              <v-col class="page-control-bg" cols="12">
                <v-btn
                  :disabled="!$auth.manage"
                  @click="openCommunicationWindow(null, 'Add')"
                  class="btn btn-add"
                >
                  {{ $t('btn.common.add') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="2" md="1"></v-col>
          <v-col lg="4" md="5" class="filter-search">
            <v-row>
              <v-col class="mr-0 pr-0 pl-0" lg="5" md="5">
                <v-select
                  v-model="searchBy"
                  :items="searchByItems"
                  :placeholder="$t('lbl.common.searchTypePlaceHolder')"
                  @change="onFilterCommunication"
                  class="search-by data-table-select-box custom-selectbox pla-col mr-0 flat-file-selectbox"
                  height="30"
                  hide-details
                  dense
                  solo
                ></v-select>
              </v-col>
              <v-col class="ml-0 pl-0" cols="12" md="7">
                <v-text-field
                  v-model="search"
                  :placeholder="$t('lbl.common.searchPlaceHolder')"
                  @input="onFilterCommunication"
                  @click:append="onFilterCommunication"
                  @keyup.enter="onFilterCommunication"
                  class="data-table-filter-text-field search-button-data-analysis-table flat-file"
                  heigth="30"
                  append-icon="fa fa-search"
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col cols="12" class="pt-0 pb-0">
        <v-data-table
          :headers="headers"
          :items="listData"
          :hide-default-footer="true"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :fixed-header="true"
          :height="tableHeight"
          @page-count="pageCount = $event"
          :class="[
            'list-table code-table srm-list-table custom-border-table',
            totalCnt > 0 ? '' : 'custom-border-table-not-data',
          ]"
          no-data-text="No matching records found"
          :sort-desc="true"
          sort-by="update"
        >
          <template v-slot:top="{}">
            <v-dialog v-model="dialog" max-width="1100px" class="v-dialog-dark-1">
              <communicationDetailDialog
                @click-close="close($event)"
                @click-search="searchItem()"
              ></communicationDetailDialog>
            </v-dialog>
          </template>
          <template v-slot:body="{ items }">
            <tbody>
              <tr
                v-for="item in items"
                :key="item.id"
                @click="onClickRow(item)"
                :class="[selectedRow === item.id ? 'selected_row' : '']"
              >
                <td class="index-col">{{ listData.indexOf(item) + 1 }}</td>
                <td class="col-name">{{ item.name }}</td>
                <td class="text-center">{{ item.type }}</td>
                <td>{{ item.host_port }}</td>
                <td class="text-center">{{ item.update }}</td>
                <td>{{ item.updUsrId }}</td>
                <td class="text-center">
                  <v-btn
                    small
                    text
                    icon
                    @click="openCommunicationWindow(item, 'Edit')"
                    :disabled="!$auth.manage"
                  >
                    <icon-svg iconName="edit" :disabled="!$auth.manage" />
                  </v-btn>
                  <v-btn
                    :disabled="!$auth.manage"
                    @click="openCommunicationWindow(item, 'Copy')"
                    small
                    text
                    icon
                  >
                    <icon-svg iconName="copy" :disabled="!$auth.manage" />
                  </v-btn>
                  <v-btn small text icon @click="deleteItem(item)" :disabled="!$auth.manage">
                    <icon-svg iconName="delete" :disabled="!$auth.manage" />
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row v-show="totalCnt > 0" class="custom-pagination-figma-v3-last">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="12" md="12">
            <v-row>
              <v-col class="page-control-bg text-left pa-0" cols="6">
                <div class="custom-pagi-selectbox">
                  <v-select
                    v-model="itemsPerPage"
                    hide-details
                    dense
                    solo
                    :items="rowPerPage"
                    class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox"
                  >
                  </v-select>
                </div>
              </v-col>
              <v-col class="page-control-bg text-right pa-0" cols="6">
                <div class="page-showing">
                  <v-label>
                    {{ itemsPerPage * (page - 1) + 1 }} ~
                    {{ totalCnt - itemsPerPage * page > 0 ? itemsPerPage * page : totalCnt }}
                    of {{ totalCnt }}
                  </v-label>
                </div>
                <button
                  type="button"
                  @click="handlePageChange(1)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == 1
                      ? ' v-pagination__navigation--disabled'
                      : $vuetify.theme.dark
                      ? ''
                      : 'white',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-sm fa-step-backward"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="changePageByTextbox(-1)"
                  :class="[
                    'mr-3 custom-btn-first-last-paging',
                    page - 1 < 1
                      ? ' v-pagination__navigation--disabled'
                      : $vuetify.theme.dark
                      ? ''
                      : 'white',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-left"></i></span>
                  </div>
                </button>
                <v-text-field
                  v-model="pageEnter"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
                  @keyup.enter="changePageByTextbox(0)"
                ></v-text-field
                ><label>/ {{ pageCount }}</label>
                <button
                  type="button"
                  @click="changePageByTextbox(1)"
                  :class="[
                    'ml-3 custom-btn-first-last-paging',
                    page + 1 > pageCount
                      ? ' v-pagination__navigation--disabled'
                      : $vuetify.theme.dark
                      ? ''
                      : 'white',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-right"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="handlePageChange(pageCount)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == pageCount
                      ? ' v-pagination__navigation--disabled'
                      : $vuetify.theme.dark
                      ? ''
                      : 'white',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-sm fa-step-forward"></i></span>
                  </div>
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <versionHistory
        v-if="dialog.type == 'versionHistory'"
        class="custom-dialog mapper-version"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :id="dialog.id"
        title="Connector"
      ></versionHistory>
    </div>
    <dialogWindow
      ref="deleteDialog"
      :info="editedItem.name"
      size="max"
      title="Delete Connector"
      :detail="$t('msg.common.infoConfirm.detail', ['delete the Connector'])"
      color="confirmation"
      :showCancel="true"
      @select-ok="onDeleteItem(editedItem)"
    ></dialogWindow>
  </div>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { resizeTableHeight } from '@/vue-dlb/common/common';
import $ from 'jquery';
import { mapState } from 'vuex';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import versionHistory from '@/vue-caas/components/DelHistoryWorkflowDialog.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import cfg from '@/vue-caas/config/config.js';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import { openWindow } from '@/vue-dlb/utils/window-opener';

export default {
  components: {
    dialogWindow,
    SystemProgress,
    versionHistory,
    IconSvg, // 2021.12.1 SPKA-297 svg icon
  },
  data() {
    return {
      tableHeight: '',
      isCreated: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 50,
      search: '',
      listData: [],
      dialogs: [],
      arrLayoutDialog: [],
      dialogId: 1,
      dialog: false,
      totalCnt: 0,
      pageEnter: 1,
      headers: [
        { text: this.$t('tbl.common.columnNo'), value: 'INDEX', width: '30px' },
        { text: 'Name', value: 'name', width: '200px' },
        { text: 'Type', value: 'type', align: 'center', width: '90px' },
        { text: 'End Point', value: 'host_port' },
        {
          text: 'Last Update',
          value: 'update',
          align: 'center',
          width: '170px',
        },
        {
          text: 'Update User',
          value: 'updUsrId',
          align: 'left',
          width: '170px',
        },
        {
          text: 'Manage',
          value: 'manage',
          align: 'center',
          width: '120px',
          sortable: false,
        },
      ],
      s_item: {
        vname: '',
        vtype: '',
        vendpoint: '',
      },
      editedIndex: -1,
      editedItem: {
        action: '',
      },
      defaultItem: {},
      inouts: [
        {
          value: 'all',
          text: this.$t('lbl.common.conditionSearch.selectDirection'),
        },
        { value: 'I', text: 'INBOUND' },
        { value: 'O', text: 'OUTBOUND' },
      ],
      types: [
        { value: '', text: this.$t('lbl.common.conditionSearch.all') },
        { text: 'FTP', value: 'FTP' },
        { text: 'FTP(S)', value: 'FTPS' },
        { text: 'SFTP', value: 'SFTP' },
        { text: 'SMTP', value: 'SMTP' },
        { text: 'POP3', value: 'POP3' },
        { text: 'IMAP', value: 'IMAP' },
        { text: 'REST API', value: 'API' },
        { text: 'IBM MQ', value: 'IBM_MQ' },
        { text: 'Active MQ', value: 'ACTIVE_MQ' },
        { text: 'SOAP', value: 'SOAP' },
        { text: 'HTTP', value: 'HTTP' },
      ],
      searchByItems: [
        { text: this.$t('lbl.common.searchTypePlaceHolder'), value: 'all' },
        { text: 'Name', value: 'name' },
        { text: 'Type', value: 'type' },
        { text: 'Direction', value: 'in_out' },
      ],
      rowPerPage: [
        { value: 10, text: 'Show 10' },
        { value: 25, text: 'Show 25' },
        { value: 50, text: 'Show 50' },
        { value: 75, text: 'Show 75' },
        { value: 100, text: 'Show 100' },
      ],
      searchBy: 'all',
      prnrList: [{ value: '', text: this.$t('lbl.common.conditionSearch.all') }],
      isLoading: false,
      selectedRow: '',
    };
  },
  created() {
    this.searchItem();
    this.isCreated = true;
    EventBus.$on('delete-item', this.onDeleteItem);
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
    },
    ...mapState('common', {
      sysloadingTitle: 'sysloadingTitle',
    }),
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    listData() {
      return this.listData;
    },
    page() {
      this.pageEnter = this.page;
    },
  },
  methods: {
    displaySearchConditions(action) {
      if (action === 'expand') {
        $('.date-query-section').css('display', 'block');
        $('.data-query-section').css('display', 'block');
        $('.expand-search-conditions').css('display', 'none');
        $('.collapse-search-conditions').css('display', 'block');
      } else {
        $('.date-query-section').css('display', 'none');
        $('.data-query-section').css('display', 'none');
        $('.expand-search-conditions').css('display', 'block');
        $('.collapse-search-conditions').css('display', 'none');
      }
    },
    onClickRow(item) {
      this.selectedRow = item.id;
    },
    openVersionHistory(list, val) {
      let type = 'versionHistory';
      let item = {};
      item.ROWID = 0;
      item.versionList = list;
      item.comNm = val.name;
      item.item = val;
      let indexArrDialog = this.findDialog('versionHistory_0');
      if (indexArrDialog != null) {
        this.dialogs[indexArrDialog].options.item = item;
        return;
      }
      this.newDialog(item, type) - 1;
    },
    searchItem() {
      this.isLoading = true;
      this.$store
        .dispatch('getCommunicationList', this.s_item)
        .then(() => {
          this.listData = this.$store.getters.communicationList;
          this.totalCnt = this.listData.length;
          this.caculatePageCount();
          this.isLoading = false;
        })
        .catch((ex) => {
          this.isLoading = false;
        });
    },
    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      let self = this;
      if (cfg.isDlb) {
        self.$refs.deleteDialog.dialog = true;
      } else {
        this.$store
          .dispatch('getListUseInWorkflow', { type: 'COM', value: item.id })
          .then((res) => {
            if (res.length > 0) {
              self.openVersionHistory(res, item);
            } else {
              self.$refs.deleteDialog.dialog = true;
            }
          });
      }
    },
    onDeleteItem(item) {
      this.$store.dispatch('deleteComm', { id: item.id, s_item: this.s_item }).then(() => {
        this.searchItem();
      });
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    onFilterCommunication(str) {
      setTimeout(() => {
        this.$store
          .dispatch('setFilterCommunication', {
            filter: this.searchBy,
            str: this.search,
          })
          .then(() => {
            this.listData = this.$store.getters.communicationList;
            this.totalCnt = this.listData.length;
            this.caculatePageCount();
          });
      }, 300);
    },
    openCommunicationWindow(item, type) {
      let params = {};
      let isEdit = false;
      if (type === 'Edit') {
        this.editedItem = Object.assign({}, item);
        this.editedItem.action = 'edit';
        this.editedItem.formtitle = 'Modify Connector';
        this.editedItem.s_item = this.s_item;
        isEdit = true;
        params = {
          ROWID: item.id.toString(),
          editedItem: Object.assign({}, this.editedItem),
          options: {
            id: item.id.toString(),
            isEdit: isEdit,
          },
        };
      } else if (type === 'Copy') {
        this.editedItem = Object.assign({}, item);
        this.editedItem.action = 'copy';
        this.editedItem.name = '';
        this.editedItem.formtitle = 'Copy Connector';
        this.editedItem.s_item = this.s_item;
        isEdit = true;
        params = {
          ROWID: item.id.toString(),
          editedItem: Object.assign({}, this.editedItem),
          options: {
            id: item.id.toString(),
            isEdit: isEdit,
          },
        };
      } else {
        item = { id: '0' };
        this.editedItem = {};
        this.editedItem.action = 'add';
        this.editedItem.formtitle = 'Add Connector';
        this.editedItem.s_item = this.s_item;
        params = {
          ROWID: '0',
          editedItem: Object.assign({}, this.editedItem),
          options: {
            id: '0',
            isEdit: isEdit,
          },
        };
      }

      const arrView = {
        item,
        type,
      };
      const url = `/communication/commDetail/${type}/${params.ROWID}`;
      const size = 'width=1100,height=800,left=100,top=30';
      openWindow({
        arrView,
        url: url,
        params,
        size: size,
        onClose: () => {
          this.searchItem();
        },
      });
    },

    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = {
        left: 30 * this.dialogId,
        top: 30 * this.dialogId,
        item: item,
      };
      return { id, name, type, options };
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    changePageByTextbox(value) {
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page = data > this.pageCount ? this.pageCount : data < 1 ? 1 : data;
        this.pageEnter = this.page;
      }
      this.page += value;
    },
    handlePageChange(value) {
      this.page = value;
    },
    caculatePageCount() {
      if (this.totalCnt % this.itemsPerPage === 0) {
        this.pageCount = this.totalCnt / this.itemsPerPage;
      } else {
        this.pageCount = Math.floor(this.totalCnt / this.itemsPerPage) + 1;
      }
    },
  },
  updated: function() {
    let self = this;
    let arrClassMinus = ['.page-control-content'];
    let arrClassPlus = [];

    if (this.isCreated) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 'px';
      this.isCreated = false;
    }

    $(window).resize(function(event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 'px';
    });
  },
  mounted() {
    window.addEventListener('storage', (event) => {
      if (event.key === 'processSharedData') {
        const updatedState = JSON.parse(event.newValue);
        if (updatedState?.COM) {
          this.searchItem();
        }
      }
    });
  },
};
</script>
